module.exports = __webpack_public_path__ + "img/london.f3af0de9.png";